import { useState } from "react";
import { ChevronDown, ChevronRight, Calculator, Network } from "lucide-react";

const FleetOverviewCalculations = () => {
  const [openSections, setOpenSections] = useState(false);

  const toggleSection = () => {
    setOpenSections((prev) => !prev);
  };

  const scoreCalculationDetails = [
    {
      score: "Emission Score",
      formula:
        "Math.min(100, Math.round((1 - currentEmission / maxEmission) * 100))",
      variables: [
        "maxEmission = 100",
        "currentEmission = mainEngineConsMTHFO * 3.1",
        "3.1 = conversion factor for MTHFO to emissions",
      ],
      range: "0-100",
      weight: "40% of total score",
    },
    {
      score: "Performance Score",
      formula: "Math.max(0, 100 - speedDiff * 5)",
      variables: [
        "optimalSpeed = 15 knots",
        "speedDiff = |speedThroughwater - optimalSpeed|",
        "5 = penalty factor per knot deviation",
      ],
      range: "0-100",
      weight: "60% of total score",
    },
    {
      score: "Total Score",
      formula: "(Emission × 0.4) + (Performance × 0.6)",
      variables: [
        "Rounded to 1 decimal place",
        "Machinery score removed in current version",
      ],
      range: "0-100",
      weight: "Final score",
    },
  ];

  return (
    <div>
      <div className="mb-6 border border-gray-300 rounded-lg overflow-hidden">
        <button
          className="flex items-center justify-between w-full p-5 bg-gray-50 hover:bg-gray-100 transition-colors"
          onClick={toggleSection}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-[#d6eaf8] rounded-lg">
              <Network className="w-6 h-6 text-[#2e86c1]" />
            </div>
            <div className="text-left">
              <h2 className="text-md font-bold text-gray-800">
                Fleet Data Processing & Calculations
              </h2>
              <p className="text-gray-600 text-sm">
                Comprehensive fleet management with performance scoring
              </p>
            </div>
          </div>
          {openSections ? (
            <ChevronDown className="w-5 h-5 text-gray-500" />
          ) : (
            <ChevronRight className="w-5 h-5 text-gray-500" />
          )}
        </button>

        {openSections && (
          <div className="p-5 bg-white border-t border-gray-200 space-y-8">
            {/* Score Calculations */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Score Calculation Details
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {scoreCalculationDetails.map((score) => (
                  <div
                    key={score.score}
                    className="bg-amber-50 p-5 rounded-lg border border-amber-200"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <Calculator className="w-5 h-5 text-amber-600" />
                      <h4 className="font-bold text-amber-800">
                        {score.score}
                      </h4>
                    </div>

                    <div className="space-y-3">
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">
                          Formula:
                        </p>
                        <div className="text-sm bg-white p-2 rounded border border-gray-200 font-mono">
                          {score.formula}
                        </div>
                      </div>

                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">
                          Variables:
                        </p>
                        <div className="space-y-1">
                          {score.variables.map((variable, idx) => (
                            <div
                              key={idx}
                              className="text-xs bg-white p-2 rounded border"
                            >
                              {variable}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-2">
                        <div className="text-center bg-white p-2 rounded border">
                          <div className="text-xs text-gray-500">Range</div>
                          <div className="font-medium">{score.range}</div>
                        </div>
                        <div className="text-center bg-white p-2 rounded border">
                          <div className="text-xs text-gray-500">Weight</div>
                          <div className="font-medium">{score.weight}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FleetOverviewCalculations;
